const getters = {
  list: state => state.list,
  isLoading: state => state.isLoading,
  isBaseFreightLoading: state => state.isBaseFreightLoading,
  invoiceslist: state => state.invoiceslist,
  indentslist: state => state.indentslist,
  isUploading: state => state.isUploading,
  filter: state => state.filter,
  hasEmpty: state => state.hasEmpty,
  invoiceDetails: state => state.invoiceDetails,
  tempCharges: state => state.tempCharges,
  totalSystemCharges: state => state.totalSystemCharges,
  totalTransporterCharges: state => state.totalTransporterCharges,
  transporterTotalFreightCharge: state => state.transporterTotalFreightCharge,
  freightBillDetails: state => state.freightBillDetails,
  isDedicatedTruck: state => state.isDedicatedTruck,
  depotWiseDetails: state => state.depotWiseDetails,
  isAttachmentAvailable: state => state.isAttachmentAvailable,
};
export default getters;
